export default __webpack_public_path__ + "static/media/tindog.f676eb2b.png";